import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

export type MultipleChoiceQuestionAnswer = string[];

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class MultipleChoiceAnswer extends Answer {
  public answer: MultipleChoiceQuestionAnswer | undefined;

  constructor(
    id: string,
    type: AnswerType,
    answer?: MultipleChoiceQuestionAnswer,
  ) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): MultipleChoiceAnswer {
    return new MultipleChoiceAnswer(dto.id, dto.type, dto.answer);
  }
}
